import { observeHttpStatus } from "./fetch";
import { Subject } from "rxjs";
class AuthStateHolder {
    constructor(url) {
        this.authSubject = new Subject();
        this.authCheckUrl = "/server/probe";
        this.sendingAuthCheck = false;
        this.onStatus = (status) => {
            if ((status === 401 || status === 403) && this.auth) {
                this.checkAuthState();
            }
        };
        if (url) {
            this.authCheckUrl = url;
        }
        observeHttpStatus(this.onStatus);
        this.checkAuthState();
    }
    checkAuthState() {
        if (this.sendingAuthCheck)
            return;
        this.sendingAuthCheck = true;
        window.fetch(this.authCheckUrl, {
            credentials: "include",
            mode: "no-cors"
        }).then(res => {
            const prevAuth = this.auth;
            if (res.ok) {
                this.auth = true;
            }
            else if (res.status === 401 || res.status === 403 || res.type === "opaque") {
                this.auth = false;
            }
            if (this.auth !== prevAuth) {
                this.authSubject.next(this.auth);
            }
        }).catch(err => {
            // 通常是网络错误（断网等）
            console.error(err);
        }).finally(() => this.sendingAuthCheck = false);
    }
    observeAuth(callback) {
        return this.authSubject.subscribe(callback);
    }
    setCheckAuthUrl(newUrl) {
        this.authCheckUrl = newUrl;
    }
    currentAuth() {
        return this.auth;
    }
}
// 单例
let authState;
export function getAuthStateHolder() {
    if (!authState) {
        authState = new AuthStateHolder();
    }
    return authState;
}
/**
 * 修改默认的登录态检查url。
 * @param url
 */
export function setAuthCheckUrl(url) {
    if (!authState) {
        authState = new AuthStateHolder(url);
    }
    else {
        authState.setCheckAuthUrl(url);
    }
}
export function redirectToSSOLanding() {
    window.location.assign("/server/landing?to=" + encodeURIComponent(window.location.href.slice(window.location.origin.length)));
}
